import { percentFormat } from '../../utils';
import { getPercentageDiffAppearance } from './portfolioDashboardUtilities';

/** @param {{ changePercentage: number | null }} props */
export const PortfolioChangePercentage = function PortfolioChangePercentage({ changePercentage }) {
    if (changePercentage === null) return <span className="text-muted">—</span>;

    const percentageDiffAppearance = getPercentageDiffAppearance(changePercentage);

    return (
        <span className={percentageDiffAppearance.colorClass}>
            {percentageDiffAppearance.iconClass !== '' && (
                <i className={`${percentageDiffAppearance.iconClass} mr-1`}></i>
            )}
            {percentageDiffAppearance.signPrefix}{percentFormat(changePercentage)}
        </span>
    );
};
